<div class="filter-layout">
  <div class="fl-header">

    <p class="f-14 font-weight-600 mb-0">Filters</p>
    <div class="d-flex align-items-center">
          <a data-testid="auto-app-hire-filter-a-1" class="f-12 text-webbtree-green pointer mr-2 font-weight-500" *ngIf="hasActiveFilters()" (click)="resetFilter()">Reset All</a>

      <span class="f-14 font-weight-500 mr-3" *ngIf="!recCandLoader">{{formatNumberToIndianFormat(recommendCount)}} Candidate found</span>
        <span *ngIf="recCandLoader" class="spinner-border text-webbtree-green mr-3">
          <span class="sr-only">Loading...</span>
      </span>
      <div class="d-flex">
        <button data-testid="auto-app-hire-filter-button-1" class="hire-btn-secondary mr-3" (click)="dismiss()">Cancel</button>
        @if(type == 'edit') {
    <div class="dropdown">
          <button data-testid="auto-app-hire-filter-button-2" class="hire-btn-primary dropdown-toggle" [ngClass]="{ 'remove-caret': showProjectFilterApplyLoader }" role="button" data-bs-toggle="dropdown" aria-expanded="false"
             [disabled]="isExperienceFilterInvalid()" (click)="onApplyClick($event)">
               <span style="width: 100%;">
           <span [ngClass]="{ 'spinner-border text-light spinner-size': showProjectFilterApplyLoader }"
                    [ngStyle]="{ 'width: 20px; height: 20px;': showProjectFilterApplyLoader }">
                    {{showProjectFilterApplyLoader ? '' : 'Apply'}}
                  </span>
                  </span>
          </button>
          <div class="dropdown-menu">
            <div class="p-3">
              <p class="f-16 font-weight-500 mb-1">Refresh Candidate Results?</p>
              <p class="f-14 font-weight-400 text-9696 mb-2">Applying these filters will replace the candidate list with
                newly
                matched results based on your updated criteria</p>
              <div class="d-flex">
                <button data-testid="auto-app-hire-filter-button-3" class="btn-trms-gray">
                  Cancel
                </button>
                <button data-testid="auto-app-hire-filter-button-4" class="btn-trms-medium ml-1" (click)="calledFrom == 'Project-candidate-list' ? updateProjectFilterResults(): applyFilters()"
                  [disabled]="showProjectFilterApplyLoader && showbuttonDisable">
                  <span [ngClass]="{ 'spinner-border text-light spinner-size': showProjectFilterApplyLoader }"
                    [ngStyle]="{ 'width: 20px; height: 20px;': showProjectFilterApplyLoader }">
                    {{showProjectFilterApplyLoader ? '' : 'Update results'}}
                  </span></button>
              </div>
            </div>
          </div>
        </div>
        } @else {
          <button data-testid="auto-app-hire-filter-button-5" class="hire-btn-primary" (click)="applyFilters()" >Apply</button>
        }

        <!-- } @else{
        <button data-testid="auto-app-hire-filter-button-6" class="hire-btn-primary" (click)="applyFilters()" [disabled]="isExperienceFilterInvalid()">Apply</button>

        } -->


      </div>
    </div>
  </div>
  <div class="fl-container">
    <div class="side-panel">
      <ul class="tab-list" role="tablist">
        @for (group of filterGroups; track group.id; let i = $index) {
        <li class="tab-item" [class.active]="activeTab === group.id" role="tab"
          [attr.aria-selected]="activeTab === group.id" [attr.aria-controls]="group.id"
          (click)="scrollToSection(group.id)" (keydown.enter)="scrollToSection(group.id)"
          (keydown.space)="scrollToSection(group.id)" tabindex="0">
          <span class="tab-icon" [innerHTML]="group.icon"></span>
          <span>{{ group.name }}</span>
          @if (getCategoryCount(group.id) > 0) {
          <span class="fl-count ms-auto">{{ getCategoryCount(group.id) }}</span>
          }
        </li>
        }
      </ul>


    </div>
    <div class="content-body" #scrollContainer>
      <!-- static spy scroll -->
      <!-- <div data-bs-spy="scroll" data-bs-target="#list-example" data-bs-offset="0" class="scrollspy-example" tabindex="0"> -->
      @for (tab of filterGroups; track tab.id; let i = $index){
      <div class="filter-groups-section" id="list-item-{{tab.id}}" #sectionRef [attr.role]="'tabpanel'"
        [attr.aria-labelledby]="tab.id + '-tab'">

        <!-- </div> -->
        @if(tab.id==1){
        <!-- keyboard boolean -->
        <div *ngIf="shouldShowFilter(filterNames.KEYWORD_INPUT)">
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Boolean Search</p>
            <span class="f-12" role="button" *ngIf="hasValue(keywordInputControl.value)" (click)="clearIndividualFilter('booleansearch')" style="cursor:pointer;">Clear</span>
          </div>
          <div>
            <textarea data-testid="auto-app-hire-filter-textarea-1" name="" id="" class="wc-form-control" rows="10" cols="10" [formControl]="keywordInputControl"
              placeholder="Keyword or boolean search using Job Title, Skills, Name, Company or Industry" (blur)="selectedItem($event, 'booleansearch', 'enter')"
              (keydown.enter)="selectedItem($event, 'booleansearch', 'enter')" (click)="isEditing = true"
              [ngClass]="{'save-input': !isEditing}"></textarea>
          </div>
        </div>
        }
        @if(tab.id==2){
        <!-- Roles & experience -->
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Role & Experience </p>
          </div>
          <!-- JobTitle -->
          <div class="mb-3" *ngIf="shouldShowFilter(filterNames.JOB_TITLE)">
            <div class="d-flex justify-content-between mb-1">
              <label for="jobtitle" class="label-style">Job Title</label>
              <div class="d-flex align-items-center">
                <span class="f-12 mr-2" role="button" *ngIf="jobTitleSelectedList?.length" (click)="clearIndividualFilter('jobtitle')" style="cursor:pointer;">Clear</span>
                <div class="dropdown-caret">
                  <select data-testid="auto-app-hire-filter-select-1" class="custom-select" #jobtitledropdown id="jobtitledropdown" [formControl]="jobStatus"
                    (change)="filterByStatus($event, 'jobtitle') ;updateWidth(jobtitledropdown,'jt')" style="width: 115px;">
                    <option value="Current" selected>Current</option>
                    <option value="Current or Past">Current or Past</option>
                  </select>
                </div>
              </div>
            </div>
            <input data-testid="auto-app-hire-filter-input-1" type="text" name="jobtitle" id="jobtitle" class="wc-form-control" placeholder="Type here"
              [formControl]="jobTitleControl" [matAutocomplete]="jobtitle_auto"
              (input)="searchSuggestions($event, 'jobtitle')" (keyup.enter)="selectedItem($event, 'jobtitle', 'enter')"
              (click)="showAISuggestions('jobtitle')">
            <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
              @for(jt of jobTitleList; track jt.value) {
              <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{jt.value
                    | titlecase}}</span>
                </span>
              </mat-option>
              }
            </mat-autocomplete>
            <app-custom-chip *ngIf="jobTitleSelectedList?.length" [chips]="jobTitleSelectedList" [removable]="true"
              [showExclude]="true" (removed)="removeChip($event, 'jobtitle')"
              (excluded)="excludeChip($event, 'jobtitle')" class="mb-2 d-block">
            </app-custom-chip>
            <app-hire-suggestions-list [suggestions]="fieldSuggestions?.jobtitle" [showAiLabel]="showAiSuggestionsFor('jobtitle')"
              (suggestionAdded)="selectedItem($event, 'jobtitle', 'aisuggestion')">
            </app-hire-suggestions-list>
          </div>



          <!-- Past JobTitle -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" [ngClass]="{ 'w-100': !shouldShowFilter(filterNames.SENIORITY) }" *ngIf="shouldShowFilter(filterNames.PAST_JOB_TITLE)">
              <div class="d-flex justify-content-between">
                <label for="pastjobtitle" class="label-style">Past Job Title</label>
                <span class="f-12" role="button" *ngIf="pastJobTitleSelectedList?.length" (click)="clearIndividualFilter('pastjobtitle')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-2" type="text" name="pastjobtitle" id="pastjobtitle" class="wc-form-control" placeholder="Type here"
                [formControl]="pastJobTitleControl" [matAutocomplete]="pastjobtitle_auto"
                (input)="searchSuggestions($event, 'pastjobtitle')"
                (keyup.enter)="selectedItem($event, 'pastjobtitle', 'enter')"
                (click)="showAISuggestions('pastjobtitle')">
              <mat-autocomplete #pastjobtitle_auto="matAutocomplete"
                (optionSelected)="selectedItem($event, 'pastjobtitle')">
                @for(jt of pastjobTitleList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="pastJobTitleSelectedList?.length" [chips]="pastJobTitleSelectedList"
                [removable]="true" [showExclude]="true" (removed)="removeChip($event, 'pastjobtitle')"
                (excluded)="excludeChip($event, 'pastjobtitle')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.pastjobtitle" [showAiLabel]="showAiSuggestionsFor('pastjobtitle')"
                (suggestionAdded)="selectedItem($event, 'pastjobtitle', 'aisuggestion')">
              </app-hire-suggestions-list>
            </div>
            <!--Seniority -->
            <div class="w-50" [ngClass]="{ 'w-100': !shouldShowFilter(filterNames.PAST_JOB_TITLE) }" *ngIf="shouldShowFilter(filterNames.SENIORITY)">
              <div class="d-flex justify-content-between">
                <label for="seniority" class="label-style">Seniority</label>
                <span class="f-12" role="button" *ngIf="senioritySelectedList?.length" (click)="clearIndividualFilter('seniority')" style="cursor:pointer;">Clear</span>
              </div>
              <div class="mb-2 advsearchpinput">
                <p-multiSelect [options]="seniorityList" [formControl]="seniorityControl"
                  (onChange)="senioritySelection($event)" placeholder="Select Seniority" optionLabel="name"
                  [filter]="false">
                  <ng-template let-value pTemplate="selectedItems">
                    <span *ngIf="value?.length">
                      {{ value.length }} selected
                    </span>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                      <div class="p-multiselect-header-checkbox">
                        <span class="p-checkbox-label">All</span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-cs pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ cs | titlecase}}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
              <app-custom-chip *ngIf="senioritySelectedList?.length" [chips]="senioritySelectedList" [removable]="true"
                (removed)="removeChip($event, 'seniority')" class="mb-2 d-block">
              </app-custom-chip>
            </div>
          </div>

          <!--Years of Experience -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.YEARS_OF_EXPERIENCE)">
              <div class="d-flex justify-content-between mb-1">
                <label for="yearofexp" class="label-style">Years of Experience</label>
                <div class="d-flex align-items-center">
                  <span class="f-12 mr-2" role="button" *ngIf="hasValue(fromYearsControl.value) || hasValue(toYearsControl.value)" (click)="clearIndividualFilter('experience')" style="cursor:pointer;">Clear</span>
                  <div class="dropdown-caret">
                    <select data-testid="auto-app-hire-filter-select-2" class="custom-select" #yoedropdown id="yearofexp" [formControl]="experienceStatus"
                      (change)="filterByStatus($event, 'experience');updateWidth(yoedropdown,'yoe')">
                      <option value="Total" selected>Total</option>
                      <option value="Average">Average</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between align-items-center mr-2">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    From
                  </div>
                  <div>
                    <input data-testid="auto-app-hire-filter-input-3" type="text" name="yearofexp" id="yearofexp" class="wc-form-control" placeholder="Type here"
                      [formControl]="fromYearsControl" (keyup)="searchSuggestions($event, 'fromYears')">
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    To
                  </div>
                  <div>
                    <input data-testid="auto-app-hire-filter-input-4" type="text" name="jobtitle" id="jobtitle" class="wc-form-control" placeholder="Type here"
                      [formControl]="toYearsControl" (keyup)="searchSuggestions($event, 'toYears')">
                  </div>
                </div>
              </div>
               <p style="margin-left: 45px;"
          *ngIf="(toYearsControl.value != null && toYearsControl.value != '' && fromYearsControl.value != '' && fromYearsControl.value != null) && (+fromYearsControl.value > +toYearsControl.value) && !(+fromYearsControl.value < 0 || +fromYearsControl.value > 40 || +toYearsControl.value < 0)"
          class="f-12 text-danger"> Invalid Input </p>
        <p style="margin-left: 45px;"
          *ngIf="+fromYearsControl.value < 0 || +fromYearsControl.value > 40 || +toYearsControl.value > 40 || +toYearsControl.value < 0"
          class="f-12 text-danger"> Enter a valid number in the range (0 – 40)</p>
          <!-- {{fromYearsControl.hasError('invalidYears') || toYearsControl.hasError('invalidYears') | json}}
          <p style="margin-left: 45px;" *ngIf="fromYearsControl.hasError('invalidYears') || toYearsControl.hasError('invalidYears')">To Years should be greater than fromYears</p> -->
            </div>
            <!--Years in current Compnay -->
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.YEARS_OF_EXPERIENCE_CURRENT_COMPANY)">
              <div class="d-flex justify-content-between mb-1">
                <label class="label-style">Years in current Company</label>
                <span class="f-12" role="button" *ngIf="hasValue(currentFromYearsControl.value) || hasValue(currentToYearsControl.value)" (click)="clearIndividualFilter('currentexperience')" style="cursor:pointer;">Clear</span>
              </div>
              <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between align-items-center mr-2">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    From
                  </div>
                  <div>
                    <input data-testid="auto-app-hire-filter-input-5" type="text" name="currentFromYears" id="currentFromYears" class="wc-form-control"
                      placeholder="Type here" [formControl]="currentFromYearsControl"
                      (keyup)="searchSuggestions($event, 'fromCurrentYears')">
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    To
                  </div>
                  <div>
                    <input data-testid="auto-app-hire-filter-input-6" type="text" name="currentToYears" id="currentToYears" class="wc-form-control"
                      placeholder="Type here" [formControl]="currentToYearsControl"
                      (keyup)="searchSuggestions($event, 'toCurrentYears')">
                  </div>
                </div>
              </div>
               <p style="margin-left: 45px;"
          *ngIf="(currentToYearsControl.value != null && currentToYearsControl.value != '' && currentFromYearsControl.value != '' && currentFromYearsControl.value != null) && (+currentFromYearsControl.value > +currentToYearsControl.value) && !(+currentFromYearsControl.value < 0 || +currentFromYearsControl.value > 40 || +currentToYearsControl.value < 0)"
          class="f-12 text-danger"> Invalid Input </p>
        <p style="margin-left: 45px;"
          *ngIf="+currentFromYearsControl.value < 0 || +currentFromYearsControl.value > 40 || +currentToYearsControl.value > 40 || +currentToYearsControl.value < 0"
          class="f-12 text-danger"> Enter a valid number in the range (0 – 40)</p>
            </div>
          </div>


        </div>
        }
        @if(tab.id==3){
        <!-- COMPANY, COMPANY SIZE AND INDUSTRY FILTER SECTION  -->
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Company </p>
          </div>

          <!-- Company -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" [ngClass]="{'w-100' : !shouldShowFilter(filterNames.COMPANY_SIZE) }" *ngIf="shouldShowFilter(filterNames.COMPANY)">
              <div class="d-flex justify-content-between mb-1">
                <label for="Company" class="label-style">Company</label>
                <div class="d-flex align-items-center">
                  <span class="f-12 mr-2" role="button" *ngIf="companySelectedList?.length" (click)="clearIndividualFilter('company')" style="cursor:pointer;">Clear</span>
                  <div class="dropdown-caret">
                    <select data-testid="auto-app-hire-filter-select-3" class="custom-select" #companydropdown name="companydropdown" id="companydropdown"
                      [formControl]="companyStatus"
                      (change)="filterByStatus($event, 'company'); updateWidth(companydropdown, 'company')" style="width: 115px;">
                      <option value="Current" selected>Current</option>
                      <option value="Past">Past</option>
                      <option value="Current or Past">Current or Past</option>
                    </select>
                  </div>
                </div>
              </div>
              <input data-testid="auto-app-hire-filter-input-7" type="text" name="Company" id="Company" class="wc-form-control" placeholder="Type here"
                [formControl]="companyControl" [matAutocomplete]="company_auto"
                (input)="searchSuggestions($event, 'company')" (keyup.enter)="selectedItem($event, 'company', 'enter')"
                (click)="showAISuggestions('company')">
              <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'company')">
                @for(jt of companyList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="companySelectedList?.length" [chips]="companySelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'company')"
                (excluded)="excludeChip($event, 'company')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.company"
                (suggestionAdded)="selectedItem($event, 'company', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            <!--Company Size -->
            <div class="w-50" [ngClass]="{'w-100' : !shouldShowFilter(filterNames.COMPANY) }" *ngIf="shouldShowFilter(filterNames.COMPANY_SIZE)">
              <div class="d-flex justify-content-between">
                <label for="companysize" class="label-style" style="height: 21px;">Company Size</label>
                <span class="f-12" role="button" *ngIf="companysizeSelectedlist?.length" (click)="clearIndividualFilter('companysize')" style="cursor:pointer;">Clear</span>
              </div>
              <div class="mb-2 advsearchpinput">
                <p-multiSelect [options]="companySizeOption" [formControl]="companysizeControl"
                  (onChange)="companySizeSelection($event)" placeholder="Select Company Size" optionLabel="name"
                  [selectedItemsLabel]="'Select Company Size'" [display]="'chip'" [filter]="false">

                  <ng-template let-value pTemplate="selectedItems">
                    <span *ngIf="value?.length">
                      {{ value.length }} selected
                    </span>
                  </ng-template>

                  <ng-template pTemplate="header">
                    <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                      <span class="p-ml-2">All</span>
                    </div>
                  </ng-template>

                  <ng-template let-cs pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ cs }}</div>
                    </div>
                  </ng-template>

                </p-multiSelect>
              </div>
              <app-custom-chip *ngIf="companysizeSelectedlist?.length" [chips]="companysizeSelectedlist"
                [removable]="true" (removed)="removeChip($event, 'companysize')" class="mb-2 d-block">
              </app-custom-chip>
            </div>
          </div>

          <!-- INDUSTRY -->
          <div class="d-flex justify-content-between gap-3 mb-3" *ngIf="shouldShowFilter(filterNames.INDUSTRIES)">
            <!--Industry -->
            <div class="w-50">
              <div class="d-flex justify-content-between mb-1">
                <label for="industry" class="label-style">Industry</label>
                <div class="d-flex align-items-center">
                  <span class="f-12 mr-2" role="button" *ngIf="industrySelectedList?.length" (click)="clearIndividualFilter('industry')" style="cursor:pointer;">Clear</span>
                  <div class="dropdown-caret">
                    <select data-testid="auto-app-hire-filter-select-4" class="custom-select" #industrydropdown id="industrydropdown" name="industrydropdown"
                      [formControl]="industryStatus"
                      (change)="filterByStatus($event, 'industry');updateWidth(industrydropdown,'ind')" style="width: 115px;">
                      <option value="Current" selected>Current</option>
                      <option value="Past">Past</option>
                      <option value="Current or Past">Current or Past</option>
                    </select>
                  </div>
                </div>
              </div>
              <input data-testid="auto-app-hire-filter-input-8" type="text" name="industry" id="industry" class="wc-form-control" placeholder="Type here"
                [formControl]="industryControl" [matAutocomplete]="industry_auto"
                (input)="searchSuggestions($event, 'industry')"
                (keyup.enter)="selectedItem($event, 'industry', 'enter')" (click)="showAISuggestions('industry')">
              <mat-autocomplete #industry_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'industry')">
                @for(jt of industryList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="industrySelectedList?.length" [chips]="industrySelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'industry')"
                (excluded)="excludeChip($event, 'industry')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.industry"
                (suggestionAdded)="selectedItem($event, 'industry', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            <div class="w-50">
              &nbsp;
            </div>
          </div>


        </div>
        }

        @if(tab.id==4){
        <!-- Skills & Expertise -->
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Skills & Expertise </p>
          </div>

          <!-- Skill -->
          <div class="d-flex justify-content-between gap-3 mb-3" *ngIf="shouldShowFilter(filterNames.SKILLS)">
            <div class="w-100">
              <div class="d-flex justify-content-between mb-1">
                <label for="skills" class="label-style">Skills</label>
                <span class="f-12" role="button" *ngIf="skillsSelectedList?.length" (click)="clearIndividualFilter('skills')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-9" type="text" name="skills" id="skills" class="wc-form-control" placeholder="Type here"
                [formControl]="skillsControl" [matAutocomplete]="skills_auto"
                (input)="searchSuggestions($event, 'skills')" (keyup.enter)="selectedItem($event, 'skills', 'enter')"
                (click)="showAISuggestions('skills')">
              <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skills')">
                @for(jt of skillsList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="skillsSelectedList?.length" [chips]="skillsSelectedList" [removable]="true"
                [showExclude]="true" [showMandatory]="true" (removed)="removeChip($event, 'skills')"
                (excluded)="excludeChip($event, 'skills')" (mandatory)="onMandatoryChip($event, 'skills')"
                class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.skills" [showAiLabel]="showAiSuggestionsFor('skills')"
                (suggestionAdded)="selectedItem($event, 'skills', 'aisuggestion')">
              </app-hire-suggestions-list>

            </div>
          </div>
          <!--Fucntion -->
          <div class="d-flex justify-content-between gap-3 mb-3" *ngIf="shouldShowFilter(filterNames.FUNCTIONS)">
            <div class="w-50">
              <div class="d-flex justify-content-between">
                <label for="function" class="label-style">Functions</label>
                <span class="f-12" role="button" *ngIf="functionSelectedList?.length" (click)="clearIndividualFilter('function')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-10" type="text" name="function" id="function" class="wc-form-control" placeholder="Type here"
                [formControl]="functionControl" [matAutocomplete]="function_auto"
                (input)="searchSuggestions($event, 'function')"
                (keyup.enter)="selectedItem($event, 'function', 'enter')" (click)="showAISuggestions('function')">
              <mat-autocomplete #function_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'function')">
                @for(jt of functionList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="functionSelectedList?.length" [chips]="functionSelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'function')"
                (excluded)="excludeChip($event, 'function')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.function"
                (suggestionAdded)="selectedItem($event, 'function', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            <div class="w-50">
              &nbsp;
            </div>
          </div>


        </div>
        }
        @if(tab.id==5){
        <!-- Location-->
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14 ">Location<i class="fa-regular fa-circle-info f-12 ml-1"
                *ngIf="(defaultContinents && (locationSelectedList?.length == 0 && locationContinents?.length == 0))"
                [ngbTooltip]="tooltipTemplate" placement="bottom"></i>
            </p>
            <ng-template #tooltipTemplate>
              Showing results for <b>{{ defaultContinents | titlecase }}</b>, add locations to search globally.
            </ng-template>
          </div>

          <!-- Location -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" [ngClass]="{'w-100' : !shouldShowFilter(filterNames.DISTANCE) }" *ngIf="shouldShowFilter(filterNames.LOCATION)">
              <div class="d-flex justify-content-between">
                <label for="location" class="label-style">Location</label>
                <span class="f-12" role="button" *ngIf="locationSelectedList?.length" (click)="clearIndividualFilter('location')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-11" type="text" name="location" id="location" class="wc-form-control" placeholder="Type here"
                [formControl]="locationControl" [matAutocomplete]="location_auto"
                (input)="searchSuggestions($event, 'location')" (click)="showAISuggestions('location')">
              <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
                @for(jt of locationList; track jt.value) {
            <mat-option
  [value]="{key: jt.value, doc_count: jt.doc_count, location_type: jt.location_type, continent: jt.location_continent}"
  [disabled]="isLocationDisabled(jt)">
  <span
    class="d-flex align-items-center tooltip-wrapper"
    [matTooltip]="getTooltipText(jt)"
    [matTooltipClass]="{ 'eu-tooltip text-black': true }"
    matTooltipPosition="above">
    <span class="text-truncate">{{ jt.value | titlecase }}</span>
  </span>
</mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="locationSelectedList?.length" [chips]="locationSelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'location')"
                (excluded)="excludeChip($event, 'location')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.location"
                (suggestionAdded)="selectedItem($event, 'location', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            <!-- Distance -->
            <div class="w-50 d-flex" [ngClass]="{'w-100' : !shouldShowFilter(filterNames.LOCATION) }" *ngIf="shouldShowFilter(filterNames.DISTANCE)">
              <div class="mr-1 w-100">
              <div class="d-flex justify-content-between">
                <label for="distance" class="label-style">Distance <i class="fa-regular fa-circle-info f-12 ml-1" matTooltip="Distance filter is effective only for city level locations" matTooltipPosition="above" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></label>
                <span class="f-12" role="button" *ngIf="distanceControl.value != 100 || distanceUnitControl.value != 'kilometers'" (click)="clearIndividualFilter('distance')" style="cursor:pointer;">Clear</span>
              </div>
                <input data-testid="auto-app-hire-filter-input-12" type="text" name="distance" id="distance" class="wc-form-control" placeholder="Type here"
                  [formControl]="distanceControl"
                  [ngClass]="{'disabled-input': locationSelectedList?.length == 0 || location_type != 'city'}"
                  [disabled]="locationSelectedList?.length == 0 || location_type != 'city'"
                  (keyup)="searchSuggestions($event, 'distance')" min="0" max="500">
              </div>
              <div>
                <label class="label-style" style="height: 13px;">&nbsp;</label>
                <div class="dropdown-caret distance-dropdown">
                <select data-testid="auto-app-hire-filter-select-5" name="distance" id="distance" class="wc-form-control caret-remove" [formControl]="distanceUnitControl"
                  [ngClass]="{'disabled-input': locationSelectedList?.length == 0 || location_type != 'city'}"
                  [disabled]="locationSelectedList?.length == 0 || location_type != 'city'"
                  (change)="searchSuggestions($event, 'distanceUnit')">
                  <option value="kilometers">Kms</option>
                  <option value="miles">Miles</option>
                </select>
                </div>
              </div>
              <p *ngIf="distanceControl?.errors?.pattern" class="text-danger f-12 pt-1">
                Only whole numbers are allowed</p>
              <p *ngIf="distanceControl.errors?.min && (distanceControl.dirty || distanceControl.touched)"
                class="f-12 text-danger m-0"> Value should be greater than 0</p>
              <p *ngIf="distanceControl.errors?.max && (distanceControl.dirty || distanceControl.touched)"
                class="f-12 text-danger m-0"> Value should be less than 500</p>
              <p *ngIf="!distanceControl?.value && (distanceControl.dirty || distanceControl.touched)"
                class="f-12 text-danger m-0">
                This field is required</p>
            </div>
          </div>
        </div>
        }
        @if(tab.id==6){
        <!-- Education-->
        <div>
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Education </p>
          </div>

          <!-- Education -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.EDUCATION)">
              <div class="d-flex justify-content-between">
                <label for="education" class="label-style">Education</label>
                <span class="f-12" role="button" *ngIf="educationSelectedList?.length" (click)="clearIndividualFilter('education')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-13" type="text" name="education" id="education" class="wc-form-control" placeholder="Type here"
                [formControl]="educationControl" [matAutocomplete]="education_auto"
                (input)="searchSuggestions($event, 'education')"
                (keyup.enter)="selectedItem($event, 'education', 'enter')" (click)="showAISuggestions('education')">
              <mat-autocomplete #education_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'education')">
                @for(jt of educationList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="educationSelectedList?.length" [chips]="educationSelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'education')"
                (excluded)="excludeChip($event, 'education')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.education"
                (suggestionAdded)="selectedItem($event, 'education', 'enterSuggestions')">
              </app-hire-suggestions-list>
            </div>
            <!-- School -->
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.SCHOOL)">
              <div class="d-flex justify-content-between">
                <label for="school" class="label-style">School</label>
                <span class="f-12" role="button" *ngIf="schoolSelectedList?.length" (click)="clearIndividualFilter('school')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-14" type="text" name="school" id="school" class="wc-form-control" placeholder="Type here"
                [formControl]="schoolControl" [matAutocomplete]="school_auto"
                (input)="searchSuggestions($event, 'school')" (keyup.enter)="selectedItem($event, 'school', 'enter')"
                (click)="showAISuggestions('school')">
              <mat-autocomplete #school_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'school')">
                @for(jt of schoolList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="schoolSelectedList?.length" [chips]="schoolSelectedList" [removable]="true"
                [showExclude]="true" (removed)="removeChip($event, 'school')" (excluded)="excludeChip($event, 'school')"
                class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.school"
                (suggestionAdded)="selectedItem($event, 'school', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
          </div>
          <!-- Field of Study -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.FIELD_OF_STUDY)">
              <div class="d-flex justify-content-between">
                <label for="fieldofstudy" class="label-style">Field of Study</label>
                <span class="f-12" role="button" *ngIf="fieldOfStudySelectedList?.length" (click)="clearIndividualFilter('fieldofstudy')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-15" type="text" name="fieldofstudy" id="fieldofstudy" class="wc-form-control" placeholder="Type here"
                [formControl]="fieldOfStudyControl" [matAutocomplete]="fieldofstudy_auto"
                (input)="searchSuggestions($event, 'fieldofstudy')"
                (keyup.enter)="selectedItem($event, 'fieldofstudy', 'enter')"
                (click)="showAISuggestions('fieldofstudy')">
              <mat-autocomplete #fieldofstudy_auto="matAutocomplete"
                (optionSelected)="selectedItem($event, 'fieldofstudy')">
                @for(jt of fieldOfStudyList; track jt.value) {
                <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
              <app-custom-chip *ngIf="fieldOfStudySelectedList?.length" [chips]="fieldOfStudySelectedList"
                [removable]="true" [showExclude]="true" (removed)="removeChip($event, 'fieldofstudy')"
                (excluded)="excludeChip($event, 'fieldofstudy')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.fieldofstudy"
                (suggestionAdded)="selectedItem($event, 'fieldofstudy', 'enterSuggestions')">
              </app-hire-suggestions-list>
            </div>
            <!-- Education Location -->
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.EDUCATION_LOCATION)">
              <div>
                <div class="d-flex justify-content-between">
                  <label for="educationLocation" class="label-style">Location of Education</label>
                  <span class="f-12" role="button" *ngIf="schoolLocationSelectedList?.length" (click)="clearIndividualFilter('school_location')" style="cursor:pointer;">Clear</span>
                </div>

                <input data-testid="auto-app-hire-filter-input-16" type="text" name="educationLocation" id="educationLocation" class="wc-form-control"
                  placeholder="Type here" [formControl]="educationLocationControl"
                  [matAutocomplete]="educationlocation_auto" (input)="searchSuggestions($event, 'school_location')"
                  (keyup.enter)="selectedItem($event, 'school_location', 'enter')"
                  (click)="showAISuggestions('school_location')">
                <mat-autocomplete #educationlocation_auto="matAutocomplete"
                  (optionSelected)="selectedItem($event, 'school_location')">
                  @for(jt of schoolLocationList; track jt.value) {
                  <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
                    [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{jt.value
                        | titlecase}}</span>
                    </span>
                  </mat-option>
                  }
                </mat-autocomplete>
                <app-custom-chip *ngIf="schoolLocationSelectedList?.length" [chips]="schoolLocationSelectedList"
                  [removable]="true" [showExclude]="true" (removed)="removeChip($event, 'school_location')"
                  (excluded)="excludeChip($event, 'school_location')" class="mb-2 d-block">
                </app-custom-chip>
                <app-hire-suggestions-list [suggestions]="fieldSuggestions?.school_location"
                  (suggestionAdded)="selectedItem($event, 'school_location', 'enterSuggestions')">
                </app-hire-suggestions-list>
              </div>

            </div>
          </div>
          <!-- graduation year -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.GRADUATION_YEAR)">
              <div class="d-flex justify-content-between">
                <label class="label-style">Years of graduation</label>
                <span class="f-12" role="button" *ngIf="hasValue(fromgraduationyearControl.value) || hasValue(tograduationyearControl.value)" (click)="clearIndividualFilter('graduationyear')" style="cursor:pointer;">Clear</span>
              </div>

              <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between align-items-center mr-2">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    From
                  </div>
                   <div class="dropdown-caret distance-dropdown">
                  <select data-testid="auto-app-hire-filter-select-6" name="fromgraduationyear" placeholder="YYYY" [formControl]="fromgraduationyearControl"
                    style="width: fit-content;" (change)="searchSuggestions($event, 'fromgraduationyear')"
                    class="wc-form-control position-relative no-outline inputheight wc-select caret-remove2">
                    <option value="" selected disabled>Select year</option>

                    <span *ngFor="let year of graduationYearList('from')">
                      <option [value]=year>{{year}}</option>
                    </span>
                  </select>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="gap-2 f-12 text-9696 mr-2">
                    To
                  </div>
                  <div>
                     <div class="dropdown-caret distance-dropdown">
                    <select data-testid="auto-app-hire-filter-select-7" name="tograduationyear" placeholder="YYYY" [formControl]="tograduationyearControl"
                      style="width: fit-content;" (change)="searchSuggestions($event, 'tograduationyear')"
                      class="wc-form-control position-relative no-outline inputheight wc-select caret-remove2">
                      <option value="" selected disabled>Select year</option>

                      <span *ngFor="let year of graduationYearList('to')">
                        <option [value]=year>{{year}}</option>
                      </span>
                    </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        }
        @if(tab.id==7){
        <!-- Profile / Identity-->
        <div *ngIf="shouldShowFilter(filterNames.FULL_NAME) || shouldShowFilter(filterNames.GENDER)">
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Profile / Identity </p>
          </div>

          <!-- Name -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            @if(calledFrom == 'Project-candidate-list' || shouldShowFilter(filterNames.FULL_NAME)) {
            <div class="w-50" [ngClass]="{'w-100' : !shouldShowFilter(filterNames.GENDER)}" *ngIf="shouldShowFilter(filterNames.FULL_NAME)">
              <div class="d-flex justify-content-between">
                <label for="name" class="label-style">Name</label>
                <span class="f-12" role="button" *ngIf="fullNameSelectedList?.length" (click)="clearIndividualFilter('fullname')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-17" type="text" name="name" id="name" class="wc-form-control" placeholder="Type here"
                [formControl]="fullNameControl" [matAutocomplete]="fullname_auto"
                (input)="searchSuggestions($event, 'fullname')" (keyup.enter)="selectFullName($event, 'enter')"
                (click)="showAISuggestions('fullname')">
              <mat-autocomplete #fullname_auto="matAutocomplete" (optionSelected)="selectFullName($event)">
                @if(fullNameControl?.value) {
                <mat-option [value]="fullNameControl?.value">{{fullNameControl?.value | titlecase}}</mat-option>
                }

                @for(jt of profiles; track jt.value) {
                <mat-option [value]="jt" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                  <span class="f-12 text-9696" *ngIf="jt?.job_title">{{jt?.job_title}}<span
                      *ngIf="jt?.job_title && jt?.job_company_name">@</span><span
                      *ngIf="jt?.job_company_name">{{jt?.job_company_name}}</span></span>
                </mat-option>
                }

              </mat-autocomplete>
              <app-custom-chip *ngIf="fullNameSelectedList?.length" [chips]="fullNameSelectedList" [removable]="true"
                [showExclude]="false" (removed)="removeChip($event, 'fullname')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.fullname"
                (suggestionAdded)="selectedItem($event, 'fullname', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            } @else {
            <div class="w-50"  *ngIf="shouldShowFilter(filterNames.NAME_WITH_LINKEDIN_URL)">
              <div class="d-flex justify-content-between">
                <label for="name" class="label-style">Name/Linkedin Url</label>
                <span class="f-12" role="button" *ngIf="fullNameSelectedList?.length" (click)="clearIndividualFilter('fullname')" style="cursor:pointer;">Clear</span>
              </div>
              <input data-testid="auto-app-hire-filter-input-18" type="text" name="name" id="name" class="wc-form-control" placeholder="Type here"
                [formControl]="fullNameControl" [matAutocomplete]="fullname_auto"
                (input)="searchSuggestions($event, 'fullname')" (keyup.enter)="selectFullName($event, 'enter')"
                (click)="showAISuggestions('fullname')">
              <mat-autocomplete #fullname_auto="matAutocomplete" (optionSelected)="selectFullName($event)">
                @if(!isFullNameLinkedinUrl && fullNameControl?.value) {
                <mat-option [value]="fullNameControl?.value">{{fullNameControl?.value | titlecase}}</mat-option>
                }

                @for(jt of profiles; track jt.value) {
                <mat-option [value]="jt" [matTooltip]="jt.value | titlecase"
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                  <span class="d-flex align-items-center">
                    <span class="text-truncate">{{jt.value
                      | titlecase}}</span>
                  </span>
                  <span class="f-12 text-9696" *ngIf="jt?.job_title">{{jt?.job_title}}<span
                      *ngIf="jt?.job_title && jt?.job_company_name">@</span><span
                      *ngIf="jt?.job_company_name">{{jt?.job_company_name}}</span></span>
                </mat-option>
                }

              </mat-autocomplete>
              <app-custom-chip *ngIf="fullNameSelectedList?.length" [chips]="fullNameSelectedList" [removable]="true"
                [showExclude]="false" (removed)="removeChip($event, 'fullname')" class="mb-2 d-block">
              </app-custom-chip>
              <app-hire-suggestions-list [suggestions]="fieldSuggestions?.fullname"
                (suggestionAdded)="selectedItem($event, 'fullname', 'enterSuggestions')">
              </app-hire-suggestions-list>

            </div>
            }



            <!-- Gender -->
            <div class="w-50 d-flex" *ngIf="shouldShowFilter(filterNames.GENDER)">
              <div class="w-100">
                <label for="gender" class="label-style d-flex justify-content-between">Gender
                  <span class="f-12" role="button" *ngIf="genderFormControl.value && genderFormControl.value !== 'All'" (click)="clearIndividualFilter('gender')" style="cursor:pointer;">Clear</span>
                </label>
                <div class="d-flex justify-content-between align-items-center" style="height: 30px;">
                  <span><input data-testid="auto-app-hire-filter-input-19" type="radio" name="gender" value="All" class="mr-1" [formControl]="genderFormControl"
                      (change)="searchSuggestions($event, 'gender')">All</span>
                  <span><input data-testid="auto-app-hire-filter-input-20" type="radio" name="gender" value="Male" class="mr-1" [formControl]="genderFormControl"
                      (change)="searchSuggestions($event, 'gender')">Men</span>
                  <span><input data-testid="auto-app-hire-filter-input-21" type="radio" name="gender" value="Female" class="mr-1" [formControl]="genderFormControl"
                      (change)="searchSuggestions($event, 'gender')">Women</span>

                </div>
              </div>

            </div>
          </div>
        </div>
        }
        @if(tab.id==8){
        <!-- Power Filters-->
        <div *ngIf="shouldShowFilter(filterNames.HIGHLIGHTS) || shouldShowFilter(filterNames.WEBBTREE_TRUE_LEVEL)">
          <div class="d-flex justify-content-between">
            <p class="mb-1 font-weight-600 f-14">Power Filters</p>
          </div>

          <!-- Highlights -->
          <div class="d-flex justify-content-between gap-3 mb-3">
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.HIGHLIGHTS)">
              <div class="d-flex justify-content-between">
                <label for="highlights" class="label-style">Highlights</label>
                <span class="f-12" role="button" *ngIf="highlightsSelectedList?.length" (click)="clearIndividualFilter('highlights')" style="cursor:pointer;">Clear</span>
              </div>
              <div class="advsearchpinput  highlight-select">
                <p-multiSelect [options]="highLightOptions" optionLabel="label" optionValue="id"
                  [formControl]="highlightSelectedControl" (onChange)="onChangeHighlights($event)"
                   [filter]="false"    placeholder="Select Highlight"
    selectedItemsLabel="{0} selected"
    [maxSelectedLabels]="0">

                  <ng-template pTemplate="header">
                    <div class="flex align-items-center gap-2"
                      style="position: absolute!important; left: 36px!important;">
                      <div class="p-multiselect-header-checkbox">
                        <span class="p-checkbox-label">All</span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-cs pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div class="highlight-pill" ngClass="highlight-pill-{{cs.color}}">
                        <span *ngIf="cs?.imageName" class="mr-1">
                          <img [src]="'assets/highlights/' + cs.imageName + '.svg'" alt="">
                        </span>
                        {{ cs.label }}
                      </div>
                    </div>
                  </ng-template>
                </p-multiSelect>
                <app-custom-chip *ngIf="highlightsSelectedList?.length" [chips]="highlightsSelectedList"
                  [removable]="true" (removed)="removeChip($event, 'highlights')" class="mb-2 d-block">
                </app-custom-chip>
              </div>
            </div>
            <div class="w-50" *ngIf="shouldShowFilter(filterNames.WEBBTREE_TRUE_LEVEL)">
              <div class="d-flex justify-content-between">
                <label for="Webbtree" class="label-style">Webbtree True Level <i class="fa-regular fa-circle-info f-12 ml-1" matTooltip="This filter rationalizes roles by considering both job seniority and company size to enable fair comparisons-for example, a VP at a startup is categorized differently from a VP at a global enterprise." matTooltipPosition="above" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></label>
                <span class="f-12" role="button" *ngIf="positionhierarchyList?.length" (click)="clearIndividualFilter('positionhierarchy')" style="cursor:pointer;">Clear</span>
              </div>
              <div>
                <p-multiSelect [options]="positionHierarchyData" [formControl]="positionhierarchyControl"
                  (onChange)="changePositionHierarchy($event)" placeholder="Select Position Hierarchy"
                  optionLabel="name" [filter]="false">
                  <ng-template let-value pTemplate="selectedItems">
                    <span *ngIf="value?.length">
                      {{ value.length }} selected
                    </span>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <div class="flex align-items-center gap-2"
                      style="position: absolute!important; left: 36px!important;">
                      <div class="p-multiselect-header-checkbox">
                        <span class="p-checkbox-label">All</span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-ph pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ ph | titlecase }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
              <app-custom-chip *ngIf="positionhierarchyList?.length" [chips]="positionhierarchyList" [removable]="true"
                (removed)="removeChip($event, 'positionhierarchy')" class="mb-2 d-block">
              </app-custom-chip>
            </div>

          </div>
        </div>
        }
      </div>
      }

    </div>
  </div>
</div>


<ng-template #refreshCandidateResult class="modal">
  <div class="modal-content p-3">
    <p class="f-14 font-weight-500 mb-1">Refresh Candidate Results?</p>
    <p class="f-12 font-weight-400 text-9696 mb-2">Applying these filters will replace the candidate list with newly
      matched results based on your updated criteria</p>
    <div class="d-flex">
      <button data-testid="auto-app-hire-filter-button-7" class="btn-trms-gray" (click)="dismiss()">
        Cancel
      </button>
      <button data-testid="auto-app-hire-filter-button-8" class="btn-trms-medium ml-1" (click)="updateProjectFilterResults()">Update results</button>
    </div>
  </div>
</ng-template>
